module.exports = __webpack_public_path__ + "media/images/flags/je-ad293465b67d91aeb9dd6521e052f322.svg";